
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import Testable from '@/mixins/Testable'
import { namespace } from 'vuex-class'
import { Product } from '@/models/accounting/Product'

const ProductsCache = namespace('accountingProducts')

@Component
export default class ProductSelector extends Mixins(Testable) {
	@Prop({ required: true })
	value!: Product | null

	@ProductsCache.Action('findAll')
	fetchAll

	@ProductsCache.Getter('peekAll')
	peekAll

	@ProductsCache.Getter('hasColdCache')
	hasColdCache

	internalModel: Product | null = null

	debouncedQuery: () => Promise<void> | undefined = () => Promise.resolve()

	get products() {
		return this.peekAll()
	}

	get loading() {
		return this.hasColdCache()
	}

	get includingInitial() {
		return ([this.value, ...this.products].filter(Boolean) as Array<Product>).reduce(
			(unique, product) =>
				unique.find((c) => product.getApiId() === c.getApiId()) ? unique : [...unique, product],
			[] as Array<Product>
		)
	}

	async created() {
		this.internalModel = this.value
		await this.fetchAll()
	}

	clearSearchResults() {
		this.$emit('clear')
	}

	emitInput(product: Product | null) {
		// Check to ensure only actual products are emitted
		if (typeof product?.getApiId !== 'function') {
			return
		}

		this.$emit('input', product)
	}

	@Watch('value')
	valueChanged(val) {
		this.internalModel = this.value
	}
}
